export var PasskeyLoginSource;
(function (PasskeyLoginSource) {
    PasskeyLoginSource["TextField"] = "text-field";
    PasskeyLoginSource["OneTap"] = "one-tap";
    PasskeyLoginSource["ErrorSoft"] = "error-soft";
    PasskeyLoginSource["ErrorHard"] = "error-hard";
})(PasskeyLoginSource || (PasskeyLoginSource = {}));
